import React, { useEffect, useState } from 'react';

/**
 * custom hooks for getting div element height
 */
function useDivElementHeight(ref: React.RefObject<HTMLDivElement | null>) {
  const [height, setHeight] = useState(0);

  useEffect(() => {
    if (ref.current) {
      const refStyles = window.getComputedStyle(ref.current);
      const marginTop = parseInt(refStyles.getPropertyValue('margin-top'));
      const marginBottom = parseInt(refStyles.getPropertyValue('margin-bottom'));
      setHeight(ref.current.offsetHeight + marginTop + marginBottom);
    }
  }, [ref]);

  return height;
}

export default useDivElementHeight;
